  <template v-if="true">
  <div :class="nopadding ? 'mb-0': ''">
    <div
        role="tab"
        class="card-header py-2 px-2" :class="isLocked"
        :style="headerColor ? $bgColor(headerColor) : ''"
        :aria-expanded="active"
        @click.prevent="activate"
        @click="emitId">
      <a
        data-toggle="collapse"
        data-parent="#accordion"
        :class="{course}"
        :href="`#${itemId}`"
        :aria-controls="`content-${itemId}`"
      >
      <slot name="title">
        <span :title="title">
            {{ $trim(title, 35) }}
        </span>
      </slot>
      </a>
    </div>
    <collapse-transition :duration="animationDuration">
      <div
        v-show="active"
        :id="`content-${itemId}`"
        role="tabpanel"
        :aria-labelledby="title"
        class="collapsed"
      >
        <div
            class="card-body"
            :class="nopadding ? 'px-0 py-0': ''"
            :style="bodyColor ? $bgColor(bodyColor) : ''"
        >
            <slot></slot>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
    name: 'CollapseItem',

    components: {
        CollapseTransition,
    },

    props: {
        nopadding: Boolean,
        locked: {
            type: Boolean,
            default: false,
            description: 'Lock icon',
        },
        title: {
            type: String,
            default: '',
            description: 'Collapse item title',
        },
        bodyColor: String,
        headerColor: String,
        id: [String, Number],
        course: Boolean,
    },
    inject: {
        animationDuration: {
            default: 250,
        },
        multipleActive: {
            default: false,
        },
        addItem: {
            default: () => {},
        },
        removeItem: {
            default: () => {},
        },
        deactivateAll: {
            default: () => {},
        },
    },

    computed: {
        itemId() {
            return this.id || this.title;
        },
        isLocked() {
            if (this.locked) return 'nch--locked';
            return null;
        },
    },

    data() {
        return {
            active: false,
        };
    },

    methods: {
        emitId() {
            this.$emit('onSelect', this.id);
        },
        activate() {
            if (this.locked) {
                return;
            }
            const wasActive = this.active;
            if (!this.multipleActive) {
                this.deactivateAll();
            }
            this.active = !wasActive;
        },
    },

    mounted() {
        this.addItem(this);
    },

    unmounted() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
        this.removeItem(this);
    },
};
</script>
<style lang="sass">
.accordion .nch--locked:after
  display: none

.nch--locked
  cursor: default !important

.accordion .card-header:after
  font-size: 20px

.card-header
  border-radius: none
</style>
<style scoped lang="sass">
.v-tooltip__content
    background: #616161
    border-radius: 2px
    color: #fff
    font-size: 12px
    display: inline-block
    padding: 5px 8px
    position: absolute !important
    text-transform: none
    width: auto
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)

.v-tooltip__content[class*=-active]
    transition: .15s cubic-bezier(.25,.8,.5,1)
    pointer-events: none

.v-tooltip__content--fixed
    position: fixed

.custom-tooltip
    width: 80%
    top: 40px !important
    opacity: 1 !important
.course
    color: black !important
    text-decoration: none
    font-weight: bold
</style>
